import { render, staticRenderFns } from "./s3-multi-uploader.vue?vue&type=template&id=464fee75"
import script from "./s3-multi-uploader.vue?vue&type=script&lang=ts"
export * from "./s3-multi-uploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464fee75')) {
      api.createRecord('464fee75', component.options)
    } else {
      api.reload('464fee75', component.options)
    }
    module.hot.accept("./s3-multi-uploader.vue?vue&type=template&id=464fee75", function () {
      api.rerender('464fee75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/s3-multi-uploader/s3-multi-uploader.vue"
export default component.exports